import { Url } from '../shared/Url';
import Post from '../shared/Post';
import PostFile from '../shared/PostFile';
import { cookieData } from '../funciones/ConsultaUser';
import PostAttachtmen from '../shared/PostAttachtmen';

export const ChkEmail = (id, fecha, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            idE: id,
            fecha: fecha
        }
        Post(`${Url}CheckInbox`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    })
}

export const ChkEmailF = (id, fecha, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            idE: id,
            fecha: fecha
        }
        Post(`${Url}CheckInboxF`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    })
}

export const ChkEmailNoLeidos = (id, tipo, search, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            idE: id,
            tipo: tipo,
            search: search
            /* tipo: ".Sent",
            search: "ALL" */
        }

        Post(`${Url}CheckInboxNoLeidos`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    })
}

export const VerEmail = (uId, fecha, email, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            eId: uId,
            fecha: fecha,
            email: email
        }
        Post(`${Url}VerEmail`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    })
}

export const Consult = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}consult`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    })
}

export const SearchCorreos = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
        }

        Post(`${Url}SearchCorreos`, Content, (resp) => {
            let data = JSON.parse(resp);
            let contenido = [];

            for (let i in data[0]){
                contenido.push({
                    value: data[0][i].id,
                    label: data[0][i].user_email
                })
            }

            respuesta(contenido)
        });
    })
}

export const AddMail = (servidor, puerto, flagSelect, servidorSaliente, puertoSaliente, flagSelectSaliente, email, pass, respuesta) => {
    let emailReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
    
    switch (true) {
        case (servidor === ""):
            respuesta({tipo: "error", mensaje: "El campo Servidor Entrante es obligatorio"})
        break;
        case (puerto === ""):
            respuesta({tipo: "error", mensaje: "El campo Puerto Entrante es obligatorio"})
        break;
        case (!isNaN(Number(puerto)) === false):
            respuesta({tipo: "error", mensaje: "El campo Puerto Entrante debe contener solo números"})
        break;
        case (servidorSaliente === ""):
            respuesta({tipo: "error", mensaje: "El campo Servidor Saliente es obligatorio"})
        break;
        case (puertoSaliente === ""):
            respuesta({tipo: "error", mensaje: "El campo Puerto Saliente es obligatorio"})
        break;
        case (!isNaN(Number(puertoSaliente)) === false):
            respuesta({tipo: "error", mensaje: "El campo Puerto Saliente debe contener solo números"})
        break;
        case (email === ""):
            respuesta({tipo: "error", mensaje: "El campo Nombre de Usuario es obligatorio"})
        break;
        case (emailReg.test(email) === false):
            respuesta({tipo: "error", mensaje: "El Nombre de Usuario debe tener el formato correcto"})
        break;
        case (pass === ""):
            respuesta({tipo: "error", mensaje: "El campo Contraseña es obligatorio"})
        break;
        default:
            cookieData((cookie) => {
                let Content = {
                    uId: cookie[1],
                    servidor: servidor,
                    puerto: puerto,
                    flagSelect: flagSelect,
                    servidorSaliente: servidorSaliente,
                    puertoSaliente: puertoSaliente,
                    flagSelectSaliente: flagSelectSaliente,
                    email: email,
                    pass: pass
                }
                Post(`${Url}AddMail`, Content, (resp) => {
                    let data = JSON.parse(resp);
                    respuesta(data[0])
                });
            })
    }
    
}

export const Fecha = (dat) => {
    if (dat === "") return null;

    let f = new Date(dat);
    let today = new Date();
    let meses = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
    let fecha1 = `${today.getDate()}/${today.getMonth()}/${today.getFullYear()}`
    let fecha2 = `${f.getDate()}/${f.getMonth()}/${f.getFullYear()}`

    switch (true) {
        /* Mismo Día */
        case (fecha1 === fecha2):
            let hours = f.getHours()
            let minutes = f.getMinutes()
            let ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;
            minutes = minutes < 10 ? `0${minutes}` : minutes;

            return `${hours}:${minutes} ${ampm}`;
        /* Mismo año */
        case (f.getFullYear() === today.getFullYear()):
            return `${f.getDate()} ${meses[f.getMonth()]}`;
        default:
        return fecha2;
    }
}

export const iconos = (tipo, tip2) => {
    let icono = ""
    switch (tipo) {
        case "PDF": icono = { icono: "fa fa-file-pdf-o", color: "b21f09" }; break;
        case "TXT": icono = { icono: "fa fa-file-text-o", color: "4798f8" }; break;
        case "DOC": icono = { icono: "fa fa-file-word-o", color: "094eb2" }; break;
        case "DOCX": icono = { icono: "fa fa-file-word-o", color: "094eb2" }; break;
        case "VND.OPENXMLFORMATS-OFFICEDOCUMENT.WORDPROCESSINGML.DOCUMENT": icono = { icono: "fa fa-file-word-o", color: "094eb2" }; break;
        case "XLS": icono = { icono: "fa fa-file-excel-o", color: "467d06" }; break;
        case "XLSX": icono = { icono: "fa fa-file-excel-o", color: "467d06" }; break;
        case "VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET": icono = { icono: "fa fa-file-excel-o", color: "467d06" }; break;
        case "PPT": icono = { icono: "fa fa-file-powerpoint-o", color: "c17b01" }; break;
        case "PPTS": icono = { icono: "fa fa-file-powerpoint-o", color: "c17b01" }; break;
        case "PPS": icono = { icono: "fa fa-file-powerpoint-o", color: "c17b01" }; break;
        case "PPSX": icono = { icono: "fa fa-file-powerpoint-o", color: "c17b01" }; break;
        case "JPG": icono = { icono: "fa fa-file-picture-o", color: "4d017f" }; break;
        case "JPEG": icono = { icono: "fa fa-file-picture-o", color: "4d017f" }; break;
        case "PNG": icono = { icono: "fa fa-file-picture-o", color: "4d017f" }; break;
        case "GIF": icono = { icono: "fa fa-file-picture-o", color: "4d017f" }; break;
        case "BMP": icono = { icono: "fa fa-file-picture-o", color: "4d017f" }; break;
        case "MP3": icono = { icono: "fa fa-file-audio-o", color: "b21f09" }; break;
        case "WAV": icono = { icono: "fa fa-file-audio-o", color: "b21f09" }; break;
        case "WMA": icono = { icono: "fa fa-file-audio-o", color: "b21f09" }; break;
        case "MP4": icono = { icono: "fa fa-file-movie-o", color: "094eb2" }; break;
        case "WMV": icono = { icono: "fa fa-file-movie-o", color: "094eb2" }; break;
        case "AVI": icono = { icono: "fa fa-file-movie-o", color: "094eb2" }; break;
        case "MPEG": icono = { icono: "fa fa-file-movie-o", color: "094eb2" }; break;
        case "ZIP": icono = { icono: "fa fa-file-zip-o", color: "a80012" }; break;
        case "RAR": icono = { icono: "fa fa-file-zip-o", color: "a80012" }; break;
        default:  icono = { icono: "fa fa-file-file-o", color: "333" }; break;
    }

    return icono[tip2]
}

export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    let k = 1024;
    let dm = decimals < 0 ? 0 : decimals;
    let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export const downloadAttachment = (Email, fecha, filename, UId, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            Email: Email,
            fecha: fecha,
            filename: filename,
            Uid: UId
        }

        PostFile(`${Url}downloadAttachment`, Content, filename, (resp) => {
            respuesta(resp)
        });
    })
}

export const addAttachment = (id, respuesta) => {
    let file = document.createElement('input');
    file.type = "file";
    file.setAttribute("style", "display:none");
    let idA = `attachment_${id}`
    file.id = idA
    document.getElementById('attachments').appendChild(file);
    file.click();   
    file.onchange = () => {
        let archivo = file.value;
        let extension = archivo.split('.').pop();
        let fic = archivo.split('\\');
        let nombre = fic[fic.length -1];
        let size = file.files[0].size;
          
        respuesta([nombre, extension, size, idA])
    }
}

export const sendNewMail = (adjuntos, remitente, email1, emails, asunto, body, respuesta) => {
    
    let expRegEmail = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
    let EmailsCorrectos = [];
    let EmailsNulos = [];
    let errores = true;
    let mess = {
        tipo: "info",
        text: ""
    }

    switch(true){
        case (remitente === ""):
            errores = true;
            mess = {
                tipo: "error",
                text: "Debes seleccionar el remitente"
            }
        break;
        case (email1 === "" && emails.length === 0):
            errores = true;
            mess = {
                tipo: "error",
                text: "Debes tener al menos un destinatario"
            }
        break;
        case (email1 !== "" && emails.length === 0):
            if (expRegEmail.test(email1) === false) {
                errores = true;
                mess = {
                    tipo: "error",
                    text: "Formato de correo incorrecto"
                }
            }
        case (emails.length > 0):
            if (email1 !== "") (expRegEmail.test(email1) === true) ? EmailsCorrectos.push({ tipo: "D", email: email1 }) : EmailsNulos.push(email1)
            
            emails.map(email => {
                (expRegEmail.test(email.email) === true) ? EmailsCorrectos.push({ tipo: email.tipo, email: email.email }) : EmailsNulos.push(email.email)
            })

            if (EmailsNulos.length > 0 && EmailsCorrectos.length > 0){
                errores = false;
                mess = {
                    tipo: "warning",
                    text: "Mensaje enviado, algunos destinatarios tienen formato INCORRECTO y fueron ignorados"
                }
            }else if (EmailsNulos.length > 0 && EmailsCorrectos.length === 0){
                errores = true;
                mess = {
                    tipo: "error",
                    text: "No se envió el mensaje porque los destinatarios tienen formato INCORRECTO"
                }
            }else if (EmailsNulos.length === 0 && EmailsCorrectos.length > 0){
                errores = false;
                mess = {
                    tipo: "info",
                    text: "Mensaje enviado"
                }
            }

        break;
    }
    
    if (errores === false) {
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                remitente: remitente,
                correos: EmailsCorrectos,
                asunto: asunto,
                body: body
            }

            PostAttachtmen(`${Url}sendNewMail`, adjuntos, Content, (resp) => {
                let data = JSON.parse(resp);
                respuesta(data[0])
            });
        })
    }else{
        respuesta(mess)
    }
}

export const sendReplyMail = (adjuntos, remitente, email1, emails, asunto, body, respuesta) => {
    
    let expRegEmail = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
    let EmailsCorrectos = [];
    let EmailsNulos = [];
    let errores = true;
    let mess = {
        tipo: "info",
        text: ""
    }

    switch(true){
        case (remitente === ""):
            errores = true;
            mess = {
                tipo: "error",
                text: "Debes seleccionar el remitente"
            }
        break;
        case (email1 === "" && emails.length === 0):
            errores = true;
            mess = {
                tipo: "error",
                text: "Debes tener al menos un destinatario"
            }
        break;
        case (email1 !== "" && emails.length === 0):
            if (expRegEmail.test(email1) === false) {
                errores = true;
                mess = {
                    tipo: "error",
                    text: "Formato de correo incorrecto"
                }
            }
        case (emails.length > 0):
            if (email1 !== "") (expRegEmail.test(email1) === true) ? EmailsCorrectos.push({ tipo: "D", email: email1 }) : EmailsNulos.push(email1)
            
            emails.map(email => {
                (expRegEmail.test(email.email) === true) ? EmailsCorrectos.push({ tipo: email.tipo, email: email.email }) : EmailsNulos.push(email.email)
            })

            if (EmailsNulos.length > 0 && EmailsCorrectos.length > 0){
                errores = false;
                mess = {
                    tipo: "warning",
                    text: "Mensaje enviado, algunos destinatarios tienen formato INCORRECTO y fueron ignorados"
                }
            }else if (EmailsNulos.length > 0 && EmailsCorrectos.length === 0){
                errores = true;
                mess = {
                    tipo: "error",
                    text: "No se envió el mensaje porque los destinatarios tienen formato INCORRECTO"
                }
            }else if (EmailsNulos.length === 0 && EmailsCorrectos.length > 0){
                errores = false;
                mess = {
                    tipo: "info",
                    text: "Mensaje enviado"
                }
            }

        break;
    }

    if (errores === false) {
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                remitente: remitente,
                correos: EmailsCorrectos,
                asunto: asunto,
                body: body
            }

            PostAttachtmen(`${Url}sendReplyMail`, adjuntos, Content, (resp) => {
                let data = JSON.parse(resp);
                respuesta(data[0])
            });
        })
    }else{
        respuesta(mess)
    }
}

export const sendForwardMail = (adjuntos, remitente, email1, emails, asunto, body, uId, adjuntosOr, respuesta) => {
    let expRegEmail = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;
    let EmailsCorrectos = [];
    let EmailsNulos = [];
    let errores = true;
    let mess = {
        tipo: "info",
        text: ""
    }

    switch(true){
        case (remitente === ""):
            errores = true;
            mess = {
                tipo: "error",
                text: "Debes seleccionar el remitente"
            }
        break;
        case (email1 === "" && emails.length === 0):
            errores = true;
            mess = {
                tipo: "error",
                text: "Debes tener al menos un destinatario"
            }
        break;
        case (email1 !== "" && emails.length === 0):
            if (expRegEmail.test(email1) === false) {
                errores = true;
                mess = {
                    tipo: "error",
                    text: "Formato de correo incorrecto"
                }
            }
        case (emails.length > 0):
            if (email1 !== "") (expRegEmail.test(email1) === true) ? EmailsCorrectos.push({ tipo: "D", email: email1 }) : EmailsNulos.push(email1)
            
            emails.map(email => {
                (expRegEmail.test(email.email) === true) ? EmailsCorrectos.push({ tipo: email.tipo, email: email.email }) : EmailsNulos.push(email.email)
            })

            if (EmailsNulos.length > 0 && EmailsCorrectos.length > 0){
                errores = false;
                mess = {
                    tipo: "warning",
                    text: "Mensaje enviado, algunos destinatarios tienen formato INCORRECTO y fueron ignorados"
                }
            }else if (EmailsNulos.length > 0 && EmailsCorrectos.length === 0){
                errores = true;
                mess = {
                    tipo: "error",
                    text: "No se envió el mensaje porque los destinatarios tienen formato INCORRECTO"
                }
            }else if (EmailsNulos.length === 0 && EmailsCorrectos.length > 0){
                errores = false;
                mess = {
                    tipo: "info",
                    text: "Mensaje enviado"
                }
            }

        break;
    }

    if (errores === false) {
        cookieData((cookie) => {
            let Content = {
                uId: cookie[1],
                remitente: remitente,
                correos: EmailsCorrectos,
                asunto: asunto,
                body: body,
                eId: uId,
                adjuntosOr: adjuntosOr
            }
            PostAttachtmen(`${Url}sendForwardMail`, adjuntos, Content, (resp) => {
                let data = JSON.parse(resp);
                respuesta(data[0])
            });
        })
    }else{
        respuesta(mess)
    }
}

export const StatusEmail = (email, uid, tipo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            email: email,
            eId: uid,
            tipo: tipo
        }
        Post(`${Url}StatusEmail`, Content, (resp) => {
            let data = JSON.parse(resp);
            respuesta(data[0])
        });
    })
}


// WEBPACK FOOTER //
// ./src/funciones/EmailFunction.jsx